import React, { useState } from "react";
import { Button } from "react-bootstrap";
import CandidateNoteEditor from "./CandidateNoteEditor"; // Adjust path according to your folder structure

const EditableTable = ({
  tableData,
  setTableData,
  bhina_meeting_id,
  addRowName,
  deleteRowMame,
  options,
  optionType,
  note_type,
  editors,
  setChanged,
}) => {
  const [moamadNames, setMoamadNames] = useState({});

  const addRow = () => {
    const newRow = {
      id: null,
      bhina_meeting: bhina_meeting_id,
      person_name: "",
      note_type: note_type,
      note: "",
    };
    if (tableData && Array.isArray(tableData)) {
      setTableData([...tableData, newRow]);
    } else {
      setTableData([newRow]);
    }
  };

  const deleteRow = (index) => {
    const updatedTableData = [...tableData];
    setChanged(true);
    updatedTableData.splice(index, 1);
    setTableData(updatedTableData);
  };

  const confirmDeleteRow = (index, person_name) => {
    const shouldDelete = window.confirm(
      "?" + person_name + "האם אתה בטוח שברוצנך להסיר רשומה של "
    );
    if (shouldDelete) {
      deleteRow(index);
    }
  };

  const handleSelectChange = (index, rowId, e) => {
    setChanged(true);
    const selectedName = e.target.options[e.target.selectedIndex].text;
    setMoamadNames((prevMoamadNames) => ({
      ...prevMoamadNames,
      [rowId]: selectedName,
    }));
    const updatedTableData = [...tableData];
    updatedTableData[index] = {
      ...updatedTableData[index],
      person_name: selectedName,
    };

    setTableData(updatedTableData);
  };

  return (
    <div dir="RTL">
      <Button className="btn btn-success" onClick={addRow}>
        {addRowName}
      </Button>
      {tableData?.map((row, index) => (
        <div key={index} style={{ verticalAlign: "top", marginTop: "20px" }}>
          {optionType}{" "}
          <select
            name="options"
            required
            onChange={(e) => handleSelectChange(index, row.id, e)}
          >
            <option value="">בחר {optionType}</option>
            {options?.map((j) => (
              <option
                key={j.id}
                value={j.id}
                selected={j.name === row.person_name}
              >
                {j.name}
              </option>
            ))}
          </select>{" "}
          <strong> {row.person_name != "" ? row.person_name : "הערה"}</strong>
          <Button
            className="btn btn-danger"
            onClick={() => confirmDeleteRow(index, row.person_name)}
            style={{ marginRight: "10px", marginTop: "0px" }}
          >
            {deleteRowMame}
          </Button>
          <br />
          <div style={{ marginTop: "10px" }}>
            <CandidateNoteEditor
              row={row}
              index={index}
              tableData={tableData}
              setTableData={setTableData}
              setChanged={setChanged}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default EditableTable;